import styled from 'styled-components'
import TypographyPrimary from 'components/Typography/Primary'

const ValidatorHome = () => {
    return (
        <StyledRoot>
            <TypographyPrimary size='x-large' value='Validator Reports' bold />
        </StyledRoot>
    )
}

export default ValidatorHome

const StyledRoot = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    padding-bottom: 200px;

    height: 80vh;
    width: 100%;
`
